export const ROUTE_BLOCKAGE_DETAIL_OPEN = 'ROUTE_BLOCKAGE_DETAIL_OPEN';
export const ROUTE_BLOCKAGE_DETAIL_CLOSE = 'ROUTE_BLOCKAGE_DETAIL_CLOSE';

export const routeBlockageDetailOpen = id => ({ type: ROUTE_BLOCKAGE_DETAIL_OPEN, payload: id });
export const routeBlockageDetailClose = () => ({ type: ROUTE_BLOCKAGE_DETAIL_CLOSE });
